import pick from "lodash/pick";

// Pulls out  specified type of metric (total returns all).
// TODO: REMOVE THIS
const getSelectedMetrics = (metrics, type) => {
  return type === "total" ? metrics : pick(metrics, [type]);
};

export default getSelectedMetrics;
